import { render } from "./form-hr.vue?vue&type=template&id=8303f6b8"
import script from "./form-hr.vue?vue&type=script&lang=js"
export * from "./form-hr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__